import { getBridge } from 'lmt-patientmanager/utils/bridge';
import React, { useEffect } from 'react';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';
import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ToastIcon } from '../common/icons/toast/ToastIcon';

export const MiniScreenReadFileListener = React.memo(() => {
  const readFile = useUniSelector((state) => state.measurement.readFile);
  const forms = useGlobalForms();
  const claims = useClaims();
  const i18next = useTranslation();

  useEffect(
    function handleImportFromMiniscreen() {
      if (!readFile) {
        return;
      }
      if (!claims.permissions.importMeasurements) {
        console.error(new Error(i18next.t('miniscreen.errors.no_permission')));
        toast(i18next.t('miniscreen.errors.no_permission'), {
          icon: () => <ToastIcon type="error" />,
        });
        return;
      }
      if (readFile.status === 'error') {
        console.log(readFile.error);
        console.error(new Error("Can't read the file."));
        return;
      }

      forms.importFromMiniscreen();
    },
    [readFile],
  );

  useEffect(() => {
    const bridge = getBridge();
    if (bridge) {
      setTimeout(() => bridge.miniScreenImporterReady(), 300);
    }
    return () => {};
  }, []);

  return null;
});
